module.exports = __webpack_public_path__ + "static/media/petswipe.32a21cd9.png";